import { CssBaseline } from '@material-ui/core';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import './styles/editorial.css';
import About from './components/About';
import Footer from './components/Footer';
import Header from './components/Header';
import Home from './components/Home';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import theme from './styles/theme';

function AppContent() {
  const { language } = useLanguage();

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div className="editorial-root" data-lang={language}>
          <Routes>
            <Route
              path="/"
              element={
                <div className="ed-single-page">
                  <Header />
                  <main className="ed-single-main">
                    <Home />
                    <About />
                  </main>
                  <Footer />
                </div>
              }
            />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms-of-use" element={<Terms />} />
          </Routes>
        </div>
      </Router>
    </MuiThemeProvider>
  );
}

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
